import { headerAuth } from "../standardAuthPatterns";
import { defineConnector } from "../types";
import logo from "./logo.svg";

export const discourse = defineConnector({
  identifier: "discourse",
  name: "Discourse",
  tagLine: "Community forum platform",
  logo,
  protocol: "http",
  tags: ["communication"],
  defaultUrlPattern: ({ host }) =>
    host
      ? `https://${host.replace(/\./g, "\\.")}/.*`
      : "https://[^/]*\\.discourse\\.org/.*",
  auth: (app) =>
    headerAuth([
      { name: "Api-Key", value: app.secret.apiKey },
      {
        name: "Api-Username",
        value: app.config.apiUsername,
      },
    ]),
  steps: [
    {
      title: "Get API credentials",
      items: [
        {
          kind: "markdown",
          content:
            "Visit your Discourse admin panel at **/admin/api/keys** and create a new API key.",
        },
      ],
    },
    {
      title: "Enter your instance URL",
      items: [
        {
          kind: "input",
          label: "Discourse host",
          placeholder: "forum.example.com",
          required: true,
          target: { kind: "configuration", field: "host" },
        },
      ],
    },
    {
      title: "Enter your API credentials",
      items: [
        {
          kind: "input",
          label: "API key",
          required: true,
          target: { kind: "secrets", field: "apiKey" },
        },
        {
          kind: "input",
          label: "API username",
          placeholder: "system",
          required: true,
          target: { kind: "configuration", field: "apiUsername" },
        },
      ],
    },
  ],
  connectionTest: {
    protocol: "http",
    request: ({ host }) => `https://${host}/categories.json`,
  },
});
